import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { useState } from 'react';
import client from '../../middleware/client';
import CartoonPdf from '../../components/Cartoon/CartoonPdf';
import { useParams } from 'react-router-dom';

const QUERY = gql`
  query getContentGroup($contentGroupId: Int!) {
    contentGroup {
      getContentGroup(contentGroupId: $contentGroupId) {
        contentPages(status: [PUBLISHED]) {
          id
          title
          url
          status
          sort
          parentId
          contentGroupId

          bubbleTexts {
            text
            angle
            x
            y
            w
            shape
            tailType
            isTailVisible
            assetId
            id
            character {
              id
              name
              projectId
              __typename
            }
          }

          asset {
            isAnimatedImage
            assetId
            s3Key
            contentType
          }

          featured
          releaseDate
          seoDescription
          seoTitle
        }
      }
    }
  }
`;

const CartoonPdfPage = () => {
  const [contentGroup, setContentGroup] = useState(null);

  const { contentGroupId } = useParams();

  useQuery(QUERY, {
    client,
    skip: !contentGroupId,
    variables: {
      contentGroupId: contentGroupId,
    },
    onCompleted: (data) => {
      setContentGroup(data.contentGroup.getContentGroup);
    },
  });

  return (
    <>
      {contentGroup?.contentPages.map((r) => (
        <CartoonPdf contentPage={r} />
      ))}
    </>
  );
};

export default CartoonPdfPage;
